/**
 * Shown when encrypted device storage cannot be opened at start-up. Rendered
 * outside the app's providers, so it uses the translator directly.
 */
import { browserLanguage, makeI18n } from '../lib/i18n';

export function StorageFailure({ code }: { code: 'ENCRYPTION_UNAVAILABLE' | 'DATA_INTEGRITY' | 'UNKNOWN' }) {
  const { t, dir } = makeI18n(browserLanguage());
  return (
    <main dir={dir} role="alert" className="mx-auto flex min-h-dvh max-w-md flex-col justify-center gap-4 p-6">
      <h1 className="text-xl font-semibold">{t('ui.fatal.title')}</h1>
      <p className="text-base">{t(`ui.fatal.${code}`)}</p>
      {code !== 'DATA_INTEGRITY' && (
        <button type="button" className="min-h-12 rounded-lg bg-[var(--brand)] px-4 font-medium text-white" onClick={() => location.reload()}>
          {t('ui.fatal.retry')}
        </button>
      )}
    </main>
  );
}
